import apiClient from './apiClient.js';

const clientService = {
    getAllclients(){
       return apiClient.get('/clientes/'); 
    },
    createClient(data) {
    return apiClient.post('/clientes/', data);
  },
    deleteUser(id){
        return apiClient.delete(`/clientes/${id}/`);
    },
  updateClient(id, data) {
    return apiClient.put(`/clientes/${id}/`, data);
  }
}

export default clientService;